import React from 'react';
import { useIntl } from 'react-intl';
import { Icon } from '@ui-kit';
import HeartIcon from '@ui-kit/icons/heart-accent600.svg';
import HeartIconLiked from '@ui-kit/icons/heart-error500.svg';
import { FRESHNESS_MONTHS, freshShare, formatFreshShare } from './freshness';

export const RatingItem = ({ item, ageMonths = FRESHNESS_MONTHS, isSelected = false, isPreview = false, onSelect = () => {}, onToggleLike = () => {} }) => {
  const intl = useIntl();
  const updated = new Date(item.updatedAt).toLocaleString("ru", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  // Показываем долю свежих работ по тому же порогу, который выбран в фильтре: колонка и
  // ползунок должны говорить об одном и том же, иначе результат фильтрации нечем проверить.
  const fresh = freshShare(item.avgCreationDate, ageMonths);
  return (
    <tr
      className={`rating-row${isSelected ? ' selected' : ''}`}
      onClick={() => onSelect(item)}
    >
      <td>{updated}</td>
      <td className="cell-keyword">
        {/* Ссылка ведёт на Adobe — stopPropagation, чтобы клик по ней не переключал ещё и график */}
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer"
          title={item.keyword}
          onClick={(e) => e.stopPropagation()}
        >
          {item.keyword}
        </a>
      </td>
      <td className="col-type"><span className={`badge-type badge-${item.contentType.toLowerCase()}`}>{item.contentType}</span></td>
      {/* totalResults допускает null (не спарсился с страницы Adobe) — прочерк, чтобы это не
          выглядело как ноль работ в выдаче. ?? , а не || — реальный 0 должен показываться. */}
      {/* Разряды через запятую: en-US жёстко, а не по локали интерфейса — Adobe Stock и сам
          пишет «35,889,492», и цифра должна совпадать с тем, что видно на его странице. */}
      <td>{item.totalResults == null ? '—' : Number(item.totalResults).toLocaleString('en-US')}</td>
      {/* Доля свежих работ. Прочерк — свежесть неизвестна (запись сохранена до появления
          imageIds), и это не то же самое, что «0% свежих». */}
      <td>{formatFreshShare(fresh)}</td>
      <td className="cell-score"><strong>{item.score}</strong></td>
      <td className="cell-level col-level">{item.level}</td>
      <td>{item.averageRating.toFixed(0)}</td>
      <td className="col-density">
        <div className="density-info">
          <span>Top: {item.topDensity}%</span>
          <span>Elite: {item.eliteDensity}%</span>
        </div>
      </td>
      {/* Витрина не считает лайки вовсе (публичный эндпоинт их не отдаёт), а анонимному клику
          сервер честно ответит 401 — проще не показывать кнопку там, где она не может сработать. */}
      <td className="cell-likes">
        {!isPreview && (
          <button
            type="button"
            className={`like-btn${item.isLiked ? ' liked' : ''}`}
            onClick={(e) => { e.stopPropagation(); onToggleLike(item.id); }}
            title={intl.formatMessage({
              id: item.isLiked ? 'rating.table.unlike' : 'rating.table.like',
              defaultMessage: item.isLiked ? 'Remove from favorites' : 'Add to favorites',
            })}
          >
            <Icon src={item.isLiked ? HeartIconLiked : HeartIcon} alt="like" />
            <span className="like-count">{item.likesCount || 0}</span>
          </button>
        )}
      </td>
    </tr>
  );
};